import React, { useEffect, useRef, useState } from "react"
import { useCssStyle } from "../../../../customHook/getCssStyle"
import HeaderWithBack from "../../../../components/Header/headerWithBack";
import { ScrollView, StyleSheet, Text, TextInput, View } from "react-native";
import { useTranslation } from "react-i18next";
import { DEMO_FLOW_ENABLED, MOBILE_CHECKIN_CATEGORY } from "../../../../config/Constant";
import CustomPressable from "../../../../components/customPressable/customPressable";
import { useDispatch } from "react-redux";
import { setRenderFlashMessage } from "../../../../Redux/Actions/appConfigAction";
import FetchingDataScreen from "../../../../components/fetchingDataScreen";
import { cardValidation } from "../../../../Redux/Actions/checkInAction";
import InfoPopupModal from "../../../../components/infoPopupModal";
import { CustomTextInput } from "../../../../components/customTextInput";
import { sendAnalytics } from "../../../../Redux/Actions/analyticsAction";
import { isWeb, sendMessageToFrame } from "../../../../utils/Helper";
import WebView from "react-native-webview";
import Loader from "../../../../components/Loader/loader";

export const PCIPROXY = ({ checkinSessionToken, guestDetails, isCardVerified, handleSetCardVerified, handleGoBack, handleCustomCancelClick, handleNext, handleSkip }) => {

    let pciProxy_InitURL = DEMO_FLOW_ENABLED ? "https://dev-innspire.s3.us-east-1.amazonaws.com/static/pciproxy.html" : "https://guest-journey.s3.amazonaws.com/static/pciproxy.html";

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const getStyles = useCssStyle();

    const webViewRef = useRef(null);
    const [webviewLoading, setWebviewLoading] = useState(false);

    const [disableContinueButton, setDisableContinueButton] = useState(false);


    const [loaderState, setLoaderState] = useState({
        isVisible: false,
        message: ""
    });

    const [errorState, setErrorState] = useState({
        errorStatus: false,
        errorMessage: ""
    })

    const [cardModalStatus, setCardModalStatus] = useState({
        enableCardModal: false,
        sessionUrl: ""
    })

    const updateLoaderState = (state, msg) => {
        if (state) {
            setLoaderState({ isVisible: true, message: msg });
        } else {
            setLoaderState({ isVisible: false, message: "" });
        }
    }

    const updateErrorState = (state, msg) => {
        if (state) {
            setErrorState({ errorStatus: true, errorMessage: msg });
        } else {
            setErrorState({ errorStatus: false, errorMessage: "" });
        }
    }

    const updateCardModalStatus = (status, url) => {
        if (status) {
            setCardModalStatus({ enableCardModal: true, sessionUrl: url });
            setWebviewLoading(true);
        } else {
            setCardModalStatus({ enableCardModal: false, sessionUrl: "" });
        }
    }

    const [localGuestDetails, setLocalGuestDetails] = useState(() => ({
        firstName: guestDetails?.firstName || "",
        lastName: guestDetails?.lastName || "",
        address: {
            addressLine1: guestDetails?.address?.addressLine1 || "",
            postalCode: guestDetails?.address?.postalCode || "",
        }
    }));

    const updateLocalGuestDetails = (key, value) => {
        setLocalGuestDetails(prevState => ({
            ...prevState,
            [key]: value
        }));
    };


    const updateAddressDetails = (key, value) => {
        setLocalGuestDetails(prevState => ({
            ...prevState,
            address: {
                ...prevState.address,
                [key]: value
            }
        }));
    };


    const handleCardValidationSuccess = async (response) => {

        updateLoaderState(true, "Validating card info...")

        const cardValidationPayload = {
            "confirmationNumber": guestDetails.confirmationNumber,
            "firstNameCard": localGuestDetails.firstName,
            "lastNameCard": localGuestDetails.lastName,
            "cardDigits": "",
            "vaultedCardId": response.transactionId,
            "cardTypeCode": response.cardInfo?.brand,
            "expiryDate": response.cardInfo?.expiryMonth + response.cardInfo?.expiryYear
        }

        const checkingCardInfoAsPerBooking = await cardValidation("checks", cardValidationPayload);

        if (checkingCardInfoAsPerBooking.success) {
            updateLoaderState(true, "Updating card details for the booking...");

            const updateCardInfo = await cardValidation("cardUpdate", cardValidationPayload);
            updateLoaderState(false);

            if (updateCardInfo.success) {
                console.log("card validation successfull");
                handleSetCardVerified(true);
                dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "CREDIT CARD DETAILS - SUCCESS", { "element": "widget", "widgetSessionId": checkinSessionToken }));
            } else {
                updateErrorState(true, updateCardInfo.message || "Something went wrong");
                dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "CREDIT CARD DETAILS - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "errorMessage": updateCardInfo.message || "Error during card validation: cardUpdate" }));
            }

        } else {
            updateLoaderState(false);
            updateErrorState(true, checkingCardInfoAsPerBooking.message || "Something went wrong");
            dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "CREDIT CARD DETAILS - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "errorMessage": checkingCardInfoAsPerBooking.message || "Error during card validation: checks" }));
        }
    }


    const handleCardValidationError = (errorMessage) => {

        setTimeout(() => {
            updateErrorState(true, errorMessage || "Something went wrong");
        }, 10);
    }


    const handleOnMessageReceive = (event) => {
        try {
            if (isWeb() && !pciProxy_InitURL?.includes(event.origin)) {
                return;
            }

            setDisableContinueButton(false);
            const message = isWeb() ? JSON.parse(event.data) : JSON.parse(event.nativeEvent.data);
            console.log("pci proxy rn: ", message);


            if (message.status == "approved") {
                handleCardValidationSuccess(message.response)
                return;
            }

            if (message.status == "error") {
                handleCardValidationError(message.response)
                dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "CREDIT CARD DETAILS - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "errorMessage": message.response }));
                return;
            }
        } catch (error) {
            console.log('Error in onMessage:', error);
            handleCardValidationError(error?.message || "Something went wrong");
            dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "CREDIT CARD DETAILS - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "errorMessage": error?.message || "Error during card validation" }));
        }
    };


    const handleProceedCardValidation = () => {
        setDisableContinueButton(true);
        sendMessageToFrame(webViewRef, { type: "SUBMIT_CARD_DETAILS" });
    }





    const initiateCardValidation = async () => {

        updateLoaderState(true, "Preparing card info container...")

        const cardValidationRegisterPayload = {
            "confirmationNumber": guestDetails.confirmationNumber,
            "firstNameCard": localGuestDetails.firstName,
            "lastNameCard": localGuestDetails.lastName,
            "transactionType": "ccverify"
        }

        const { success, data, message } = await cardValidation("register", cardValidationRegisterPayload);

        updateLoaderState(false);

        if (success && data.tokenStr) {

            let cardModalUrl = `${pciProxy_InitURL}?&token=${data.tokenStr}&hideSubmitButton=true`
            updateCardModalStatus(true, cardModalUrl)
        } else {
            updateErrorState(true, message || "Something went wrong");
            dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "CREDIT CARD DETAILS - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "errorMessage": message || "Error during card validation: register" }));
        }

    };

    useEffect(() => {
        dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "CREDIT CARD DETAILS", { "element": "widget", "widgetSessionId": checkinSessionToken }));
        if (!isCardVerified) initiateCardValidation();


        if (isWeb()) {
            window.addEventListener("message", handleOnMessageReceive);
        }

        return () => {
            if (isWeb()) {
                window.removeEventListener("message", handleOnMessageReceive);
            }
        };

        // eslint-disable-next-line
    }, [])


    return (
        <View style={getStyles(['widgetRootContainer', 'cardValidationRootContainer'])} showsVerticalScrollIndicator={0}>
            <HeaderWithBack handleCustomBackPress={handleGoBack} handleCustomCancelClick={handleCustomCancelClick} />

            <ScrollView automaticallyAdjustKeyboardInsets={true} contentContainerStyle={getStyles(['widgetmainContainer', 'cardValidationMainContainer'])} showsVerticalScrollIndicator={false}>

                <View style={getStyles(['widgetmainContainerHeaderContainer', 'cardValidationHeaderContainer'])}>
                    <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'cardValidationHeaderTitleContainer'])}>
                        <Text style={getStyles(['widgetmainContainerHeaderTitle', 'cardValidationHeaderTitle'])}>{t('check_in.card_validation.heading')}</Text>
                        {t('check_in.card_validation.sub_heading') && <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'cardValidationHeaderSubTitle'])}>{t('check_in.card_validation.sub_heading')}</Text>}
                    </View>
                </View>

                <View style={getStyles(['widgetmainContainerChildContainer', 'cardValidationMainContainerChildContainer'])}>

                    {cardModalStatus.enableCardModal &&
                        <View style={getStyles(['pciProxyCardContainer'])} >

                            {webviewLoading && (
                                <>
                                    <View style={{ height: "100%", justifyContent: "center", alignItems: "center" }}>
                                        <Loader style={getStyles(['crossOverContaniner_loader'])} />
                                    </View>
                                </>
                            )}

                            {isWeb() ? (
                                <iframe
                                    ref={webViewRef}
                                    src={cardModalStatus.sessionUrl}
                                    style={getStyles(['pciProxyCardContainer_iframe'])}
                                    title="PCI-Proxy"
                                    onLoad={() => setWebviewLoading(false)}
                                />
                            ) : (
                                <WebView
                                    ref={webViewRef}
                                    style={getStyles(['pciProxyCardContainer_webview'])}
                                    originWhitelist={['*']}
                                    source={{ uri: cardModalStatus.sessionUrl }}
                                    onMessage={handleOnMessageReceive}
                                    showsVerticalScrollIndicator={false}
                                    javaScriptEnabled={true}
                                    onError={(error) => console.log(error)}
                                    webviewDebuggingEnabled={true}
                                    pullToRefreshEnabled={false}
                                    cacheEnabled={true}
                                    onLoad={() => setWebviewLoading(false)}
                                />
                            )}
                        </View>
                    }

                    <View style={getStyles(['cardValidationChildContainer_buttonContainer'])}>

                        <CustomPressable style={getStyles(['primaryBtn'])} disabled={!cardModalStatus.enableCardModal || webviewLoading || disableContinueButton} onPress={handleProceedCardValidation} >
                            <Text style={getStyles(['primaryBtnTxt'])}>{t('check_in.card_validation.primary_button')}</Text>
                        </CustomPressable>

                        {DEMO_FLOW_ENABLED &&
                            <CustomPressable style={getStyles(['secondaryBtn'])} onPress={handleSkip}>
                                <Text style={getStyles(['secondaryBtnTxt'])}>{t('check_in.card_validation.skip')}</Text>
                            </CustomPressable>
                        }
                    </View>
                </View>
            </ScrollView>

            {isCardVerified &&
                <InfoPopupModal
                    type={"success"}
                    title={"Card Verified!"}
                    subtitle={"Your card was successfully verified."}
                    onContinue={() => handleNext(localGuestDetails)}
                    primaryBtnLabel={"Next"}
                />
            }

            {loaderState.isVisible && <FetchingDataScreen loaderMessage={loaderState.message} />}
            {errorState.errorStatus && <InfoPopupModal subtitle={errorState.errorMessage} onContinue={() => updateErrorState(false, "")} primaryBtnLabel={"Close"} OnRequestClose={() => updateErrorState(false, "")} />}
        </View>
    )
}